import { render, staticRenderFns } from "./NewsDetail2.vue?vue&type=template&id=1eb8c456&scoped=true&"
import script from "./NewsDetail2.vue?vue&type=script&lang=js&"
export * from "./NewsDetail2.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail2.vue?vue&type=style&index=0&id=1eb8c456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8c456",
  null
  
)

export default component.exports